var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpAssessment1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67.403,
    height: 67.403,
    viewBox: "0 0 67.403 67.403",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.282,40.72q-.023-.562-.023-1.118a26.418,26.418,0,0,1,.528-5.258L.679,32.874A33.684,33.684,0,0,0,0,39.6q0,.707.03,1.421A33.568,33.568,0,0,0,7.515,60.829l5.634-4.576A26.292,26.292,0,0,1,7.282,40.72",
    transform: "translate(0 -5.921)",
    fill: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.364,71.24A26.351,26.351,0,0,1,17.1,63.9a26.745,26.745,0,0,1-2.126-2.3L9.346,66.18A33.569,33.569,0,0,0,35.363,78.5h.022l0-7.258h-.017",
    transform: "translate(-1.684 -11.095)",
    fill: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.371,37.966h0a34.082,34.082,0,0,0-.91-6.526l-7.05,1.73a26.589,26.589,0,0,1,.709,5.1q.023.562.023,1.118A26.3,26.3,0,0,1,66.6,55.55l5.714,4.476A33.566,33.566,0,0,0,79.4,39.386q0-.707-.03-1.42",
    transform: "translate(-11.997 -5.663)",
    fill: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.254,62.986a26.343,26.343,0,0,1-18,8.135c-.294.012-.587.016-.88.018l.012,7.258c.389,0,.777-.007,1.168-.024A33.607,33.607,0,0,0,65.5,68q1.126-1.176,2.134-2.459l-5.71-4.482c-.526.666-1.081,1.309-1.668,1.922",
    transform: "translate(-7.452 -10.999)",
    fill: "#93fe89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.33,39.73l4.118-.171Z",
    transform: "translate(-13.209 -7.125)",
    fill: "#f68d00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.729,7.282q.562-.023,1.118-.023A26.274,26.274,0,0,1,48.991,9.725l3.071-6.577A33.531,33.531,0,0,0,37.848,0q-.707,0-1.42.03A33.579,33.579,0,0,0,22.9,3.49l3.247,6.49a26.338,26.338,0,0,1,10.586-2.7",
    transform: "translate(-4.124 0)",
    fill: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.761,16.206a26.527,26.527,0,0,1,7.219-5.339L18.725,4.381A33.7,33.7,0,0,0,.89,27.518L8,29a26.414,26.414,0,0,1,6.765-12.789",
    transform: "translate(-0.16 -0.789)",
    fill: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.888,15.314a26.366,26.366,0,0,1,7.371,12.692l7.048-1.737a33.716,33.716,0,0,0-18.262-22.3l-3.078,6.573a26.6,26.6,0,0,1,6.921,4.777",
    transform: "translate(-9.901 -0.714)",
    fill: "#b1b1b1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpAssessment1);
export default __webpack_public_path__ + "static/media/sp_assessment_1.f681dd2b.svg";
export { ForwardRef as ReactComponent };